import { getCurrentRuntimeConfig } from '../../config/runtime';

function readTenantId() {
  try {
    return String(getCurrentRuntimeConfig().tenant.id || 'trade-proof').trim() || 'trade-proof';
  } catch {
    return 'trade-proof';
  }
}

function normalizeSegment(value: string | number | null | undefined) {
  const segment = String(value ?? '').trim();
  return segment;
}

export function buildTenantStorageKey(baseKey: string, ...segments: Array<string | number | null | undefined>) {
  const tenantId = readTenantId();
  const normalizedBaseKey = String(baseKey || '').trim();
  const normalizedSegments = segments.map(normalizeSegment).filter(Boolean);

  return [tenantId, normalizedBaseKey, ...normalizedSegments].filter(Boolean).join(':');
}

export function readTenantStorageItem(key: string, legacyKeys: string[] = []) {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return null;

  try {
    const current = window.localStorage.getItem(key);
    if (current != null) return current;

    for (const legacyKey of legacyKeys) {
      const normalizedLegacyKey = String(legacyKey || '').trim();
      if (!normalizedLegacyKey) continue;

      const legacyValue = window.localStorage.getItem(normalizedLegacyKey);
      if (legacyValue != null) {
        window.localStorage.setItem(key, legacyValue);
        return legacyValue;
      }
    }
  } catch {
    // ignore storage failures
  }

  return null;
}

export function writeTenantStorageItem(key: string, value: string): boolean {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return false;

  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    // ignore storage failures
    return false;
  }
}

export function removeTenantStorageItem(key: string, legacyKeys: string[] = []) {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return;

  try {
    window.localStorage.removeItem(key);
    for (const legacyKey of legacyKeys) {
      const normalizedLegacyKey = String(legacyKey || '').trim();
      if (!normalizedLegacyKey) continue;
      window.localStorage.removeItem(normalizedLegacyKey);
    }
  } catch {
    // ignore storage failures
  }
}
